/**
 * Route for `performance-report-per-publisher`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PerformanceReportPerPublisherPage } from "../features/performance-report-per-publisher/PerformanceReportPerPublisherPage";

export const performanceReportPerPublisherRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/performance-report-per-publisher",
	component: PerformanceReportPerPublisherPage,
});

export default performanceReportPerPublisherRoute;
